import React from 'react';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();

  const handleBackToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '150px' }}>
      <h1 style={{ fontSize: '48px', color: 'red' }}>Unauthorized</h1>
      <p style={{ fontSize: '24px' }}>You don't have permission to access this page</p>
      <button 
        onClick={handleBackToDashboard} 
        style={{ fontSize: '18px', padding: '10px 20px', cursor: 'pointer', marginTop:'15px' }}
      >
        Back to Dashboard
      </button>
    </div>
  );
};

export default Unauthorized;
